import Icon from 'components/_UI/Icon'
import Text from 'components/_UI/Text'
import React from 'react'
import styled from 'styled-components'
import { FullyCentered } from 'styled/alignment/Center'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import colors from 'theme/colors'
import FinancialStatusIcon from '../status/FinancialStatusIcon'
import fonts from 'theme/fonts'
import currency from 'helpers/currency'
import date from 'helpers/date'
import time from 'helpers/time'

export default function GeneralWithdraws({ withdraw }) {
    return (
        <Column fullyCentralized>

            {
                withdraw?.length > 0 ? (
                    withdraw?.map((el) => (
                        <TransactionItem key={el.id}>
                            <Row>
                                <FinancialStatusIcon status={'withdraw'} />

                                <TextInfoContent>
                                    <Text paddingBottom={0} color={colors.nightDark} >
                                        Saque para a conta bancária
                                    </Text>
                                    <Text paddingBottom={0}>
                                        {`${date.format(el.created_at)} - ${time.getFormatedTime(el.created_at)}`}
                                    </Text>
                                </TextInfoContent>
                            </Row>

                            <PriceColumn>
                                <Text
                                    paddingBottom={0}
                                    color={colors.primaryLight}
                                >
                                    -{currency.format(el?.value)}
                                </Text>
                                <StatusText status='success'>
                                    Processado
                                </StatusText>
                            </PriceColumn>
                        </TransactionItem>
                    ))

                ) : (
                    <NotFoundContainer>
                        <PigIconContainer>
                            <Icon name='pig' color={colors.occasionalPurple} />
                        </PigIconContainer>

                        <Text type='bold' name='normal' color={colors.nightDark}>
                            Nenhum saque realizado
                        </Text>
                        <Text textAlign={'center'}>
                            Você ainda não efetuou nenhum saque. Verifique se possui algum valor a receber disponível e faça o primeiro repasse para sua conta bancária.
                        </Text>
                    </NotFoundContainer>
                )
            }

        </Column>
    )
}


const PigIconContainer = styled(FullyCentered)`
    width: 65px;
    height: 65px;
    padding: 18px;
    border-radius: 50%;
    background: #F3E8FF;
    margin-bottom: 10px;
`;

const NotFoundContainer = styled(FullyCentered)`
    flex-direction: column;
    padding: 40px 1.5em;
`;


const TransactionContainer = styled(Column)`
`;

const TextInfoContent = styled(Column)`
    width: auto;
`;

const TransactionItem = styled(Row)`
    margin-top: 20px;
    justify-content: space-between;
`;

const PriceColumn = styled(Column)`
    width: 150px;
    padding: 0 4px;
    text-align: center;
`;

const StatusText = styled.p`
    padding: 4px 2px;
    margin-top: 4px;
    font-size: ${fonts.sizes.small} !important;
    border-radius: 50px;
    text-align: center;
    color: ${colors.night};
    font-weight: bold;

    ${({ status }) => status === 'pending' && `
        background: #FEF9C3;
        color: ${colors.occasionalOrange};
        border: 1px solid ${colors.occasionalOrange};
    `};
    
    ${({ status }) => status === 'success' && `
        background: #DCFCE7;
        color: ${colors.successDark};
        border: 1px solid ${colors.successDark};
    `};
`